import React from 'react';
import './TrashButton.css';

/** La papelera de los listados (LAKPED-17/18). Para el clic para que la fila no se abra. */
const TrashButton = ({ title, onClick }) => (
  <button
    type="button"
    className="trash-button"
    title={title}
    aria-label={title}
    onClick={(e) => { e.stopPropagation(); onClick(); }}
  >
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 6h18" />
      <path d="M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2" />
      <path d="M19 6l-1 14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1L5 6" />
      <path d="M10 11v6M14 11v6" />
    </svg>
  </button>
);

export default TrashButton;
